module.exports = __webpack_public_path__ + "img/99.cdb7f140.jpg";